export const LEAFLET_CONSTANTS = {
    POPUP_OPEN: 'popupopen',
    POPUP_CLOSE: 'popupclose',
    LOAD: 'load',
    ZOOM_END: 'zoomend',
    ZOOM_START: 'zoomstart',
    MOVE: 'move',
    MOVE_END: 'moveend',
    ADD: 'add',
};
